"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.typingUsers.length > 0 ? _c('div', {
    staticClass: "app-typinguserslist"
  }, [_vm._m(0), _c('span', {
    staticClass: "app-typing-text"
  }, [_vm._l(_vm.typingUsers, function (user, idx) {
    return [_c('span', {
      key: user.key,
      staticClass: "app-typing-nick",
      style: {
        color: _vm.userColour(user)
      }
    }, [_vm._v(_vm._s(user.nick))]), idx < _vm.typingUsers.length - 1 ? _c('span', {
      key: `${user.key}-sep`,
      staticClass: "app-typing-sep"
    }, [_vm._v(_vm._s(idx === _vm.typingUsers.length - 2 ? ' et ' : ', '))]) : _vm._e()];
  }), _c('span', {
    staticClass: "app-typing-verb"
  }, [_vm._v(" " + _vm._s(_vm.typingVerb))])], 2)]) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "app-typing-dots",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i'), _c('i'), _c('i')]);
}];